import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatchingPeriodService } from '../../services/matchingPeriod.service';
import { MatchingPeriodDialogComponent } from '../matchingPeriod-dialog/matchingPeriod-dialog.component';
import { AuthService } from '../../auth/auth.service';
import { Permission } from '../../interfaces/permission';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-matchingPeriod',
  imports: [MatButtonModule, CommonModule],
  templateUrl: './matchingPeriod.component.html',
  styleUrl: './matchingPeriod.component.scss'
})
export class MatchingPeriodComponent {
  constructor(
    private matchingPeriodService: MatchingPeriodService,
    private readonly dialog: MatDialog,
    private readonly authService: AuthService
  ) {}
  currentMatchingPeriod?: string;
  canCreateNewMatchingperiod: boolean = false;

  ngOnInit(): void {
    this.authService.getAllPermissions$().subscribe((permissions) => {
      this.canCreateNewMatchingperiod = permissions.includes(Permission.CYCLE_START);
    });
    this.getCurrentMatchingPeriod();
  }
  async getCurrentMatchingPeriod() {
    this.matchingPeriodService.getLatestMatchingPeriod().subscribe((currentMatchingPeriodResult) => {
      if (currentMatchingPeriodResult == null) {
        this.currentMatchingPeriod = 'N/A';
      } else this.currentMatchingPeriod = currentMatchingPeriodResult.matchingPeriodName;
    });
  }

  async openDialog() {
    const dialogRef = this.dialog.open(MatchingPeriodDialogComponent, {
      width: '500px'
    });

    dialogRef.afterClosed().subscribe((result: string) => {
      if (result) {
        this.currentMatchingPeriod = result; // Assign the result to currentMatchingPeriod
        console.log(`New matchingPeriod name: ${this.currentMatchingPeriod}`);
      }
    });
  }
}
